(() => {
  const getCurrentCardIndex = (rail, cards) => {
    const railBounds = rail.getBoundingClientRect();
    const isRtl = getComputedStyle(rail).direction === 'rtl';
    const railStart = isRtl ? railBounds.right : railBounds.left;

    return cards.reduce((closestIndex, card, index) => {
      const closestCard = cards[closestIndex];
      const cardBounds = card.getBoundingClientRect();
      const closestBounds = closestCard.getBoundingClientRect();
      const cardStart = isRtl ? cardBounds.right : cardBounds.left;
      const closestStart = isRtl ? closestBounds.right : closestBounds.left;

      return Math.abs(cardStart - railStart) < Math.abs(closestStart - railStart)
        ? index
        : closestIndex;
    }, 0);
  };

  const scrollRail = (button, direction) => {
    const section = button.closest('.spirit-treatments');
    const rail = section?.querySelector('[data-spirit-treatments-rail]');
    if (!rail) return;

    const cards = Array.from(rail.querySelectorAll('.spirit-treatment-card'));
    if (!cards.length) return;

    const currentIndex = getCurrentCardIndex(rail, cards);
    const targetIndex = Math.min(Math.max(currentIndex + direction, 0), cards.length - 1);
    const target = cards[targetIndex];
    if (!target || targetIndex === currentIndex) return;

    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
    const railBounds = rail.getBoundingClientRect();
    const targetBounds = target.getBoundingClientRect();
    const styles = getComputedStyle(rail);
    const left = styles.direction === 'rtl'
      ? targetBounds.right - railBounds.right + (Number.parseFloat(styles.paddingRight) || 0)
      : targetBounds.left - railBounds.left - (Number.parseFloat(styles.paddingLeft) || 0);
    rail.scrollBy({ left, behavior });
  };

  document.addEventListener('click', (event) => {
    const previous = event.target.closest('[data-spirit-treatments-previous]');
    if (previous) {
      scrollRail(previous, -1);
      return;
    }

    const next = event.target.closest('[data-spirit-treatments-next]');
    if (next) scrollRail(next, 1);
  });
})();
